export default "__VITE_ASSET__nC423_sI__";